<template>
  <div class="main">
    <base-card v-for="toast in toasts" :key="toast.name">
      <v-card-title>{{ toast.name }}</v-card-title>
      <v-card-text>{{ toast.text }}</v-card-text>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ toast.priceS }} <br />
        {{ toast.priceL }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Shtesë</v-card-title>
    </base-card>
    <base-card v-for="side in sides" :key="side.name">
      <v-card-title>{{ side.name }}</v-card-title>
      <v-card-text>{{ side.text }}</v-card-text>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ side.priceS }} <br />
        {{ side.priceL }}
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toasts: [
        {
          name: "Kaçkavall, kërpudha",
          text: "Kërpudha, kaçkavall qumështi",
          priceS: "i vogël 120 den.",
          priceL: "i madh 140 den.",
        },
        {
          name: "Sallamë pule, кaçkavall",
          text: "Sallamë pule, kaçkavall qumështi",
          priceS: "i vogël 100 den.",
          priceL: "i madh 120 den.",
        },
        {
          name: "Kulen viçi, кaçkavall",
          text: "Kulen viçi, kaçkavall qumështi",
          priceS: "i vogël 140 den.",
          priceL: "i madh 160 den.",
        },
        {
          name: "Proshut, кaçkavall",
          text: "Proshut, kaçkavall qumështi",
          priceS: "i vogël 140 den.",
          priceL: "i madh 160 den.",
        },
        {
          name: "Ligët tost",
          text: "Kërpudha, kaçkavall pa yndyrë",
          priceS: "i vogël 100 den.",
          priceL: "i madh 130 den.",
        },
      ],
      sides: [
        {
          name: "Kaçkavall qumështi",
          text: "Me kaçkavall qumështi",
          priceS: "i vogël +30 den.",
          priceL: "i madh +40 den.",
        },
        {
          name: "Pomfrit",
          text: "Me pomfrit",
          priceS: "i vogël +30 den.",
          priceL: "i madh +40 den.",
        },
        {
          name: "Kërpudha",
          text: "Me kërpudha",
          priceS: "i vogël +30 den.",
          priceL: "i madh +40 den.",
        },
        {
          name: "Sallatë",
          text: "",
          priceS: "i vogël +20 den.",
          priceL: "i madh +30 den.",
        },
      ]
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 80vh;
  background: transparent;
}
</style>
